import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMessage } from "@fortawesome/free-solid-svg-icons";
import { profilePath } from "../../../utils/profilePath";
import { safeHref } from "../../../utils/safeHref";

export default function UserCard({ UserInfo, onMessageIconClick }) {
  const { role, firstName, lastName, website } = UserInfo;
  const path = profilePath(UserInfo);

  const picture = UserInfo.picture?.startsWith("https")
    ? UserInfo.picture
    : UserInfo.picture
    ? `${process.env.REACT_APP_AWS_URL}/${UserInfo.picture}`
    : null;

  return (
    <div className="tw-flex tw-items-center tw-gap-4 tw-px-3 tw-py-3 tw-rounded-xl tw-bg-white/5 tw-border tw-border-white/10 hover:tw-bg-white/10 tw-transition-colors">
      <Link to={path} className="tw-flex-shrink-0">
        <div className="tw-relative tw-h-12 tw-w-12">
          {picture && (
            <img
              className="tw-h-12 tw-w-12 tw-rounded-lg tw-object-cover"
              src={picture}
              alt={`${firstName} ${lastName}`}
            />
          )}
          <span className="tw-absolute tw-inset-x-0 tw-bottom-0 tw-rounded-b-lg tw-bg-black/50 tw-text-center tw-text-[9px] tw-text-white tw-leading-tight tw-py-0.5">
            {role}
          </span>
        </div>
      </Link>

      <div className="tw-flex-1 tw-min-w-0">
        <Link to={path} className="tw-no-underline">
          <p className="tw-truncate tw-text-sm tw-font-semibold tw-text-white tw-m-0">
            {firstName} {lastName}
          </p>
        </Link>
        {safeHref(website) && (
          <a
            href={safeHref(website)}
            target="_blank"
            rel="noopener noreferrer"
            className="tw-truncate tw-text-xs tw-text-white/40 hover:tw-text-white/70 tw-transition-colors"
          >
            {website}
          </a>
        )}
      </div>

      <button
        onClick={onMessageIconClick}
        className="tw-flex-shrink-0 tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-lg tw-bg-[#712CB0]/20 hover:tw-bg-[#712CB0] tw-border tw-border-[#712CB0]/40 tw-text-white/60 hover:tw-text-white tw-transition-all tw-cursor-pointer"
      >
        <FontAwesomeIcon icon={faMessage} className="tw-text-xs" />
      </button>
    </div>
  );
}
